import { Link } from "react-router-dom";
import { motion } from "motion/react";

export function ProjectThumbnail(props) {
    // let project = props.projects.find(project => project.title === props.title);
    return (
        <>
            <motion.div whileHover={{ scale: 1.1, transition: { duration: 0.2 }}} transition={{ duration: 0.3 }} class="project-thumbnail" id={props.title}>
                <Link to={ props.category === "dx11" ? "/DirectX11-Projects/" + props.id : props.category === "web" ? "/Web-Projects/" + props.id : props.category === "uiux" ? "/UIUX-Projects/" + props.id : props.category === "game" ? "/Game-Projects/" + props.id : "/Side-Quests/" + props.id}>
                    <h1 class="projthumb-text" id="projthumb-title">{props.title}</h1>
                </Link>
                {/* ^will link to a custom version of ProjectPage.js */}
                <p class="projthumb-text" id="projthumb-desc">{props.desc}</p>
                <div id="proj-tools-thumb">
                    {props.tools.map((tool) => <p>{tool}</p>)}
                </div>
                <p class="projthumb-text" id="projthumb-status"><em>{props.status}</em></p>
            </motion.div>
            
        </>
    );
};

/* when you click the thumbnail, i want:
    - create the thumbail for the project you clicked on (pass in title)
    - load the new page with the thumbnail (maybe open a new page?)
*/